import { configureStore } from "@reduxjs/toolkit";
import reportAnalysisReducer from "../Features/reportAnalysisSlice";
import orderDetailsReducer from "../Features/orderDetailsSlice";
import orderManagementReducer from "../Features/orderManagementSlice";
import dropTrackProductsReducer from "../Features/dropTrackProductsSlice";
import dropTrackActionReducer from "../Features/dropTrackActionSlice";
import searchReducer from "../Features/searchSlice";
import notificationsReducer from "../Features/notificationsSlice";
import storefrontReducer from "../Features/storefrontSlice";
import lensReducer from "../Features/lensSlice";
import inventoryManagementReducer from "../Features/inventoryManagementSlice";
import userReducer from "../Features/userSlice";
import settingsReducer from '../Features/settingsSlice';
import financeManagementReducer from '../Features/financeManagementSlice';
import dashboardReducer from '../Features/dashboardSlice';
import collectionsReducer from "../Features/collectionsSlice";
import couponsReducer from "../Features/couponsSlice";

export const store = configureStore({
    reducer: {
        dashboard: dashboardReducer,
        search: searchReducer,
        notifications: notificationsReducer,
        reportAnalysis: reportAnalysisReducer,
        orderDetails: orderDetailsReducer,
        orderManagement: orderManagementReducer,
        financeManagement: financeManagementReducer,
        dropTrackProducts: dropTrackProductsReducer,
        dropTrackAction: dropTrackActionReducer,
        storefront: storefrontReducer,
        lens: lensReducer,
        inventoryManagement: inventoryManagementReducer,
        user: userReducer,
        settings: settingsReducer,
        collections: collectionsReducer,
        coupons: couponsReducer,
    },
});
